import React, {Component} from 'react';
import { Tab, Form, Button} from 'semantic-ui-react'
import HouseCard from '../house/HouseCard';
import style from './UserProfile.scss';
import axios from "axios";
import Navbar_main from '../navbar/navbar_main.jsx';
import ReviewCard from '../review/ReviewCard';
import InterestCard from '../house/InterestCard';
import PostHouse from './post';


class UserProfile extends Component {
    constructor() {
        super();
        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
            token: localStorage.getItem('token'),
            newEmail: "",
            newPhone: "",
            newPassword: "",
            myInterest:[],
            myHouse:[],
            myReview:[],
            myReviewHouse:[]
        };
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    componentDidMount() {
        let myHouse = [],
            myInterest = [],
            myReview = [],
            myReviewHouse = [];
        const baseUrl = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/`;
        for(let i = 0; i < this.state.user.myHouse.length; i ++){
            const url = baseUrl + 'houses/' + this.state.user.myHouse[i];
            axios.get(url).then((response) => {
                if(response.data.data){
                    myHouse.push(response.data.data);
                }
                this.setState({myHouse});
            }).catch((error) => {
                console.log(error);
            });
        }
        for(let i = 0; i < this.state.user.myInterest.length; i ++){
            const url = baseUrl + 'houses/' + this.state.user.myInterest[i];
            axios.get(url).then((response) => {
                if(response.data.data){
                    myInterest.push(response.data.data);
                }
                this.setState({myInterest});
            }).catch((error) => {
                console.log(error);
            });
        }
        for(let i = 0; i < this.state.user.myReview.length; i ++){
            const url = baseUrl + 'reviews/' + this.state.user.myReview[i];
            axios.get(url).then((response) => {
                if(response.data.data){
                    myReview.push(response.data.data);
                    const url1 = baseUrl + 'houses/' +response.data.data.house;
                    axios.get(url1).then((res) => {
                        if(res.data.data){
                            myReviewHouse.push(res.data.data);
                            this.setState({myReview});
                            this.setState({myReviewHouse});
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }


    onChangeHandler(key){
        return (e) => {
            if(key === "newEmail")
                this.setState({newEmail:e.target.value});
            if(key === "newPhone")
                this.setState({newPhone:e.target.value});
            if(key === "newPassword")
                this.setState({newPassword:e.target.value});
        }
    }
    onSubmitHandler(){
        let newProfile = JSON.parse(localStorage.getItem('user'));
        if(this.state.newEmail !== "")
            newProfile.email = this.state.newEmail;
        if(this.state.newPhone !== ""){
            newProfile.phone = this.state.newPhone;
        }
        if(this.state.newPassword !== "")
            newProfile.password = this.state.newPassword;
        const url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/users/${newProfile._id}`;
        const config = {
            headers: {'Authorization': "bearer " + this.state.token}
        };
        axios.put(url, newProfile, config).then((response) => {
            localStorage.setItem('user', JSON.stringify(newProfile));
            this.setState({user:newProfile});
            window.location = `${process.env.PUBLIC_URL}/users/profile`;
        }).catch((error) => {
            console.log(error);
        });


    }

    render() {
        const MyProfile =
            <Form onSubmit={this.onSubmitHandler}>
                <Form.Field>
                    <label>Email</label>
                    <input placeholder={this.state.user.email} onChange={this.onChangeHandler("newEmail")}/>
                </Form.Field>
                <Form.Field>
                    <label>Phone</label>
                    <input placeholder={this.state.user.phone} onChange={this.onChangeHandler("newPhone")}/>
                </Form.Field>
                <Form.Field>
                    <label>New Password</label>
                    <input type='password' onChange={this.onChangeHandler("newPassword")}/>
                </Form.Field>
                <Button type='submit'>Submit</Button>
            </Form>;



        let myHouseCard = [],
            myInterestCard = [],
            myReviewCard = [];
        for(let i = 0; i < this.state.myHouse.length; i ++){
            myHouseCard.push(<HouseCard house={this.state.myHouse[i]} key={this.state.myHouse[i]._id}/>);
        }
        for(let i = 0; i < this.state.myInterest.length; i ++){
            myInterestCard.push(<InterestCard house={this.state.myInterest[i]} key={this.state.myInterest[i]._id} email={this.state.user.email}/>);
        }
        for(let i = 0; i < this.state.myReview.length; i ++){
            myReviewCard.push(<ReviewCard review={this.state.myReview[i]} house={this.state.myReviewHouse[i]} key={this.state.myReview[i]._id}/>);
        }


        const panes = [
            { menuItem: 'My Profile', render: () => <Tab.Pane>{MyProfile}</Tab.Pane> },
            { menuItem: 'My Review', render: () => <Tab.Pane>{myReviewCard}</Tab.Pane> },
            { menuItem: 'My House', render: () => <Tab.Pane>{myHouseCard}</Tab.Pane> },
            { menuItem: 'My Interest', render: () => <Tab.Pane>{myInterestCard}</Tab.Pane> }
        ];
        return (
            <div className='UserProfile'>
                <Navbar_main/>
                <div className='ProfileContent'>
                    <div className='UpperMenu'>
                        <h3 >Welcome  <span className="userName"> {this.state.user.username}! </span> </h3>
                    <PostHouse/>
                    </div>
                    <Tab menu={{ fluid: true, vertical: true }} menuPosition='left' panes={panes} />
                </div>
            </div>

        );
    }
}

export default UserProfile;